import { App } from 'vue';
import CurrencySymbol from '@/components/common/invoice/CurrencySymbol.vue';
import Price from '@/components/common/invoice/Price.vue';

export const GlobalComponentsPlugin = {
   install: (app: App) => {
      app.component('CurrencySymbol', CurrencySymbol);
      app.component('Price', Price);
   },
};

